import { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from "axios";
import getAccessTokenForHeader from "./getAccessTokenForHeader";
import { store } from "../../../lib/stores";
import { AuthActions } from "../../../lib/stores/auth/slices";
import { getCurrentLanguage } from "../../localizations/i18n";
import { apiClient, publicApiClient } from "../clients";
import * as Api from "@modules/api";
// import Toast from 'react-native-toast-message';
// import { getCurrentLocale } from '@localization';
// import store from '@modules/store';
// import { AuthActions } from '@modules/auth/module';

// export const Version = '13.9.5' //'1.0.0';
// const platform = "IOS";// Api.Server.XAppPlatform.Web;
export const Version = "1.0.0";
const platform = Api.Server.XAppPlatform.Web;

export const setupInterceptor = (
  api: AxiosInstance,
  withoutToken?: boolean
) => {
  api.interceptors.response.use(
    async (res) => {
      // console.log('res', res);
      // if(res.status === 200 && res.data && res.data?.success == false) {

      return res;
    },
    async (err: AxiosError) => {
      const data =
        typeof err.response?.data === "string"
          ? JSON.parse(err.response?.data)
          : err.response?.data;
      console.log("err", data, err);

      const url = err.config?.url;
      const statusCode = err.response?.status;
      if (url == "/api/identity/token/refresh") {
        if (statusCode === 401) {
          // TODO: Show toast message 'Your session has expired. Please login again.'
          // TODO: Logout user
          store.dispatch(AuthActions.logoutAsync());
        }
      } else {
        const message = data?.messages?.[0];
        if (message) {
          console.log("err message", message);
          // alert(message);
          // TODO: Show toast messageو message
        }
      }

      return Promise.reject({
        response: err.response,
      });
    }
  );

  // const acceptLanguage = getCurrentLocale();

  if (!withoutToken)
    api.interceptors.request.use(async (config) => {
      const token = await getAccessTokenForHeader();

      const currentLanguage = getCurrentLanguage();

      const currentLangaugeId = currentLanguage === "ar" ? "1" : "2";

      const languageId =
        config.headers["x-app-language-id"] || currentLangaugeId;

      const language = languageId === "1" ? "ar" : "en";

      const exConfig: InternalAxiosRequestConfig<any> = {
        ...config,
        headers: {
          ...config.headers,
          Authorization: "Bearer " + token,
          "accept-language": language,
          "x-app-version": Version,
          "x-app-platform": platform,
          "x-app-language-id": languageId,
        } as any,
        params: {
          ...config.params,
          culture: language,
          cacheInvalidator: new Date().getMilliseconds(),
        },
      };

      return exConfig;
    });
  else
    api.interceptors.request.use(async (config) => {
      const currentLanguage = getCurrentLanguage();

      const currentLangaugeId = currentLanguage === "ar" ? "1" : "2";

      const languageId =
        config.headers["x-app-language-id"] || currentLangaugeId;

      const language = languageId === "1" ? "ar" : "en";

      const exConfig = {
        ...config,
        headers: {
          ...config.headers,
          "accept-language": language,
          "x-app-version": Version,
          "x-app-platform": platform,
          "x-app-language-id": languageId,
        } as any,
        params: {
          ...config.params,
          cacheInvalidator: new Date().getMilliseconds(),
        },
      };

      return exConfig;
    });
};

export const setupInterceptors = () => {
  setupInterceptor(publicApiClient, true);
  setupInterceptor(apiClient);
};
